import { forwardRef, Ref } from "react"
import Box from "@mui/material/Box"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import OutlinedInput, {
  type OutlinedInputProps,
} from "@mui/material/OutlinedInput"
import Tooltip from "@mui/material/Tooltip"
import { FormErrors } from "app/components/Form/fields/FormErrors"
import Info from "@mui/icons-material/Info"

export const TextField = forwardRef(function TextField(
  {
    errors,
    id,
    label,
    value,
    onChange,
    description,
    inputProps,
    minRows = 3,
    ...props
  }: TextFieldProps,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref: Ref<any>,
) {
  return (
    <FormControl
      variant="outlined"
      error={errors && errors.length > 0}
      fullWidth={true}
    >
      {label ? (
        <InputLabel htmlFor={id}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <span>{label}</span>
            {description ? (
              <Tooltip
                title={
                  <div dangerouslySetInnerHTML={{ __html: description }} />
                }
              >
                <Info />
              </Tooltip>
            ) : null}
          </Box>
        </InputLabel>
      ) : null}
      <OutlinedInput
        id={id}
        value={value}
        onChange={onChange}
        label={label}
        inputProps={inputProps}
        minRows={minRows}
        {...props}
        ref={ref}
        fullWidth={true}
      />
      {errors ? <FormErrors errors={errors} /> : null}
    </FormControl>
  )
})

export type TextFieldProps = {
  errors?: string[]
  id: string
  description?: string
} & Pick<
  OutlinedInputProps,
  | "endAdornment"
  | "onChange"
  | "onBlur"
  | "inputRef"
  | "defaultValue"
  | "multiline"
  | "minRows"
  | "maxRows"
  | "placeholder"
  | "value"
  | "inputProps"
  | "label"
  | "name"
  | "disabled"
>
